import { useAnalyticsImpressions } from 'analytics/hooks/useAnalyticsImpressions/useAnalyticsImpressions'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver/useIntersectionObserver'
import { IMPRESSION_THRESHOLD } from 'product-card/constants/constants'
import { useProductCard } from 'product-card/hooks/useProductCard/useProductCard'
import { useProductCardConsumerLayoutContext } from 'product-card/hooks/useProductCardConsumerLayoutContext'
import { type RefObject, useCallback, useEffect } from 'react'

export const useProductCardImpression = (
	productCardRef: RefObject<HTMLFormElement | null>
) => {
	const { addImpression } = useAnalyticsImpressions()

	const { selectedColorId, productListId, lookId, productId } = useProductCard()
	const { layoutView } = useProductCardConsumerLayoutContext()

	const productCardEntry = useIntersectionObserver(productCardRef, {
		threshold: IMPRESSION_THRESHOLD,
		freezeOnceVisible: true,
	})

	const sendImpression = useCallback(() => {
		addImpression({
			colorId: selectedColorId,
			listId: productListId,
			quantity: 1,
			lookId,
			productId,
			layoutView,
		})
	}, [
		addImpression,
		lookId,
		productId,
		selectedColorId,
		productListId,
		layoutView,
	])

	useEffect(() => {
		if (productCardEntry?.isIntersecting) {
			sendImpression()
		}
	}, [productCardEntry?.isIntersecting, sendImpression])
}
